import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    moreButtonLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Icon button aria-label for shares sort/filter menu */
            moreButtonLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SharesButton.moreButtonLabel?c=3mfzdm9du5iar", defaultMessage: "Sort & Filter Shares" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
